/**
 * Clock utilities.
 *
 * SECURITY: Token validation is sensitive to clock skew.  A `clockSkewSeconds`
 * tolerance is applied symmetrically: tokens are accepted up to that many
 * seconds before `nbf` and after `exp`. Keep it small (≤ 60s) to limit the
 * replay window.
 */

export function nowSeconds(): number {
  return Math.floor(Date.now() / 1_000);
}

export function secondsFromNow(seconds: number): number {
  return nowSeconds() + seconds;
}

export function isExpired(expSec: number, clockSkewSeconds = 0): boolean {
  return nowSeconds() > expSec + clockSkewSeconds;
}

export function isNotYetValid(nbfSec: number, clockSkewSeconds = 0): boolean {
  return nowSeconds() < nbfSec - clockSkewSeconds;
}

/**
 * Validate `iat` is not unreasonably far in the past or future.
 * Malformed `iat` can indicate token forgery or extreme clock drift.
 */
export function isIatSane(iatSec: number, maxAgeSeconds: number, clockSkewSeconds = 0): boolean {
  const now = nowSeconds();
  const lower = now - maxAgeSeconds - clockSkewSeconds;
  const upper = now + clockSkewSeconds;
  return iatSec >= lower && iatSec <= upper;
}
